const emptySeverity = { critical: 0, high: 0, medium: 0, low: 0, info: 0 };

function numberAt(obj, key, fallback = 0) {
  const number = Number(obj?.[key]);
  return Number.isFinite(number) ? number : fallback;
}

export function moduleCount(rollup, key) {
  return rollup?.modules?.[key]?.total ?? 0;
}

export function moduleOpenCount(rollup, key) {
  return rollup?.modules?.[key]?.open ?? 0;
}

export function severityCounts(rollup) {
  return { ...emptySeverity, ...(rollup?.findings?.severity ?? {}) };
}

export function dashboardContractCounts(rollup) {
  const severity = severityCounts(rollup);
  const openSeverity = { ...emptySeverity, ...(rollup?.findings?.openSeverity ?? {}) };
  const osint = rollup?.osint ?? {};
  const assets = rollup?.assets ?? {};
  const sensitiveData = rollup?.modules?.sensitiveData ?? {};
  return {
    critical: severity.critical,
    high: severity.high,
    medium: severity.medium,
    low: severity.low,
    info: severity.info,
    openCriticalHigh: openSeverity.critical + openSeverity.high,
    totalFindings: numberAt(rollup?.findings, 'total'),
    openFindings: numberAt(rollup?.findings, 'open'),
    resolvedFindings: numberAt(rollup?.findings, 'resolved'),
    acceptedRiskFindings: numberAt(rollup?.findings, 'acceptedRisk'),
    assets: numberAt(assets, 'total'),
    externalIps: numberAt(assets, 'externalIps'),
    internalHosts: numberAt(assets, 'internalHosts'),
    domains: numberAt(assets, 'domains'),
    cloudResources: numberAt(assets, 'cloudResources'),
    accounts: numberAt(assets, 'accounts'),
    breachRecords: numberAt(osint, 'breachRecords'),
    exposedCredentials: numberAt(osint, 'exposedCredentials'),
    exposedServices: numberAt(osint, 'exposedServices'),
    tlsFindings: numberAt(osint, 'tlsFindings'),
    totalOsintFindings: numberAt(osint, 'total', moduleCount(rollup, 'osint')),
    osintCoverageDiagnostics: numberAt(osint, 'coverageDiagnostics'),
    sensitiveDataFindings: numberAt(sensitiveData, 'total'),
    openSensitiveDataFindings: numberAt(sensitiveData, 'open'),
    attackChains: rollup?.attackChains?.total ?? 0,
  };
}

export function pageHeaderContractCounts(rollup) {
  return {
    findings: moduleCount(rollup, 'findings'),
    cloud: moduleCount(rollup, 'cloud'),
    sensitiveData: moduleCount(rollup, 'sensitiveData'),
    osint: moduleCount(rollup, 'osint'),
    dast: moduleCount(rollup, 'dast'),
    ad: moduleCount(rollup, 'ad'),
    assets: rollup?.assets?.total ?? 0,
    attackChains: rollup?.attackChains?.total ?? 0,
  };
}
